import { create } from 'zustand';

export const useAvlReportToolTip = create((set) => ({
    errorTooltip: {
        show: false, data: {}, pos: { x: 0, y: 0 }
    },
    tooltip: {
        show: false, data: {}, pos: { x: 0, y: 0 }
    },
    setTooltip: (tooltip) => set({ tooltip }),
    setErrorTooltip: (errorTooltip) => set({ errorTooltip }),
    hideErrorTooltip: () => set({ errorTooltip: { show: false } }),
}));

export default useAvlReportToolTip;
